import React, { Component } from 'react';
import '../../styling/about/about.css';
import Header from '../shared/header.js';
import Footer from '../shared/footer.js';

class About extends Component {
  render() {
    return (
      <div>
        <Header/>
        <div className="about">
          <div className="container">
            <div className="row">
              <div className="jumbotron">
                <h4>Eventos Coworking</h4>
                <p className="lead">O maior diretório de eventos de <i>coworkings</i> de todo o Brasil!
                </p>
                <hr className="my-4"></hr>
                <p>A ideia é simples. O Brasil abraçou de vez os <i>coworkings</i> e já há centenas destes espalhados por várias cidades. Mais do que lugares para se trabalhar, esses espaços compartilhados são também núcleos de inovação e empreendedorismo. Nesse sentido, eventos de todos os tipos são organizados semanalmente nas salas de reunião, varandas, <i>rooftps</i> e auditórios dos <i>coworkings</i>.</p>
                <p>O Eventos Coworking nasce da parceria do BeerOrCoffee com o Lets.events visando:
                <ul>
                  <li>Divulgar</li>
                  <li>Centralizar</li>
                  <li>Integrar</li>
                  <li>Contribuir com ideias</li>
                </ul>
                Enfim, ser a referência em eventos para coworkings.
                </p>
                <p className="lead">
                  <a className="btn btn-primary btn-lg" href="/cadastre" role="button">Cadastre seus eventos!</a>
                </p>
              </div>
            </div>
          </div>
        </div>
        <Footer/>
      </div>
    );
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/component/about/about.js